import type { Entity } from '../../../../model/entity.model';
import { resolveShape } from '../../../../shared/entity/entity-shape.util';

/** A field a value-carrying push can set: its dotted key, its schema type, and how the picker labels it. */
export interface PushField { key: string; type: string; label: string }

const SCALAR = new Set(['STRING', 'NUMBER', 'BOOLEAN', 'TIMESTAMP', 'GEOMETRY']);
// Plumbing columns the platform fills: a builder never sets them.
const PLUMBING = new Set(['id', 'id_auto_increment', 'parent_id']);

/**
 * The fields a push can set on a new row of an entity: its own scalar fields, then the scalar fields one level into
 * each reference. Read from the resolved shape, so a reference offers its target's fields as they are now and a
 * reference to a deleted entity offers none.
 */
export function pushFieldsOf(entityId: string, entities: readonly Entity[] | null | undefined): PushField[] {
  const out: PushField[] = [];
  for (const f of resolveShape(entityId, entities)) {
    if (PLUMBING.has(f.name)) continue;
    if (SCALAR.has(f.type)) out.push({ key: f.name, type: f.type, label: f.name });
    else if (f.type === 'ENTITY_REFERENCE' && f.reach === 'followed') {
      for (const inner of f.data) {
        if (SCALAR.has(inner.type)) out.push({ key: `${f.name}.${inner.name}`, type: inner.type, label: `${f.name} — ${inner.name}` });
      }
    }
  }
  return out;
}
